import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchFormSchemaFailure,
  fetchFormSchemaSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';

const { FORM_API_BASE_URL } = urls || {};

function* fetchFormSchema({ payload: { id, cb } }) {
  try {
    const url = `${FORM_API_BASE_URL}/designs/${id}`;
  
    const response = yield request({
      method: 'get',
      url,
    });
    if (response.success) {
      yield put(fetchFormSchemaSuccess(response?.raw || {}));
      if (cb && typeof cb === 'function') {
        cb();
      }
    } else {
      yield put(fetchFormSchemaFailure(response.message));
    }
  } catch (error) {
    yield put(fetchFormSchemaFailure(String(error.message)));
  }
}

export function* getFormSchema() {
  yield takeEvery(
    ApplicantsActionTypes.START_FETCH_FORM_SCHEMA,
    fetchFormSchema
  );
}
